import { useState } from "react";

import { transformPhone } from "../../../../../../lib/utils";
import ConfirmNumberPhone, {
  IConfirmNumberPhoneData,
} from "../../../../../shared/forms/confirmNumberPhoneForm";
import { ComplexAnimatedModal } from "../../../../../ui/modal/ComplexAnimatedModal";
import Button from "../../../../../ui/button";
import useChangeNumberPhoneRequest from "../../../../../../api/hooks/use-change-phone-request";
import useChangeNumberPhone from "../../../../../../api/hooks/use-change-phone";
import styles from "./styles.module.scss";

interface IChangePhoneModalProps {
  opened: boolean;
  onClose: (value: false) => void;
  offsetY: number;
  refetch: () => Promise<void>;
}
interface IDataChangePhoneNumber {
  numberPhone: null | string;
  otp: null | string;
}

const INITIAL_DATA_CHANGE_NUMBER_PHONE = {
  numberPhone: null,
  otp: null,
};

const ChangePhoneModal = ({
  opened,
  offsetY,
  onClose,
  refetch,
}: IChangePhoneModalProps) => {
  const [dataChangeNumberPhone, setDataChangeNumberPhone] =
    useState<IDataChangePhoneNumber>(INITIAL_DATA_CHANGE_NUMBER_PHONE);

  const handleChange = (key: keyof IConfirmNumberPhoneData, data: string) => {
    setDataChangeNumberPhone((prev) => ({ ...prev, [key]: data }));
  };

  const {
    data: changePhoneDataRequest,
    error: changePhoneErrorRequest,
    isMutating: changePhoneIsMutatingRequest,
    trigger: changePhoneTriggerRequest,
  } = useChangeNumberPhoneRequest();

  const {
    error: changePhoneError,
    isMutating: changePhoneIsMutating,
    trigger: changePhoneTrigger,
  } = useChangeNumberPhone();

  const handleChangePhone = async () => {
    if (dataChangeNumberPhone.numberPhone && dataChangeNumberPhone.otp) {
      await changePhoneTrigger({
        phone: transformPhone(dataChangeNumberPhone.numberPhone),
        otp: dataChangeNumberPhone.otp,
      });
      await refetch();
      onClose(false);
    }
  };

  const handleConfirmPhone = async () => {
    if (dataChangeNumberPhone.numberPhone) {
      await changePhoneTriggerRequest({
        phone: transformPhone(dataChangeNumberPhone.numberPhone),
      });
    }
  };

  return (
    <ComplexAnimatedModal opened={opened} onClose={() => onClose(false)} offsetY={offsetY}>
      <div className={styles.changeNumberPhone}>
        <div className={styles.changeNumberPhone__container}>
          <ConfirmNumberPhone
            title="Изменить номер"
            data={{
              numberPhone: dataChangeNumberPhone?.numberPhone
                ? dataChangeNumberPhone?.numberPhone
                : "",
              otp: dataChangeNumberPhone?.otp ? dataChangeNumberPhone?.otp : "",
            }}
            onChange={handleChange}
            onActions={handleConfirmPhone}
            otp={changePhoneDataRequest?.code}
          >
            <Button
              label="Изменить номер"
              onClick={handleChangePhone}
              disabled={
                !Boolean(
                  dataChangeNumberPhone.numberPhone && dataChangeNumberPhone.otp
                )
              }
            />
          </ConfirmNumberPhone>
        </div>
      </div>
    </ComplexAnimatedModal>
  );
};

export default ChangePhoneModal;
